<div
  [tds-data-loader]="{
    key: 'activate-options',
    size: 'lg',
    as_overlay: true
  }"
  [ngClass]="[card_wrap ? 'card shadow-sm' : '']"
>
  <div [ngClass]="{ 'card-body': card_wrap }">
    <h4 class="mb-3" [ngClass]="{ 'card-title': card_wrap }">
      {{ 'device_to_activate' | translate }}
    </h4>

    @switch (loadAsset) {
      @case ('assets') {
        <div class="card mb-3 overflow-hidden asset-card">
          @if (existing_asset.line && existing_asset.line?.is_primary_contact) {
            <div
              class="position-absolute top-0 start-0 asset-card__primary"
              aria-label="Primary line"
            >
              <span class="material-icons">verified</span>
            </div>
          }
          <div class="card-body card-items card-items-md asset-card__details">
            <ts-asset-selection-item [asset]="existing_asset" [asset_fields]="asset_fields" />
          </div>
        </div>
        @if (!is_review_or_summary) {
          <form class="fw-normal" [formGroup]="sim_form">
            <div class="row">
              <div class="col col-12 col-sm-5">
                <label class="d-inline-block mb-2 required">
                  {{ 'how_to_activate_new_line' | translate }}
                </label>
                @if (simOptionAvailable('own')) {
                  <div class="form-check ps-0">
                    <input
                      id="ownSim"
                      class="d-inline-block me-1"
                      type="radio"
                      formControlName="sim_options"
                      value="own"
                      (change)="selectSimOption($event)"
                    />
                    <label class="d-inline-block mb-1" for="ownSim">
                      {{ sim_option_labels[0] }}
                    </label>
                  </div>
                }
                @if (simOptionAvailable('new')) {
                  <div class="form-check ps-0">
                    <input
                      id="newSim"
                      class="d-inline-block me-1"
                      type="radio"
                      formControlName="sim_options"
                      value="new"
                      (change)="selectSimOption($event)"
                    />
                    <label class="d-inline-block mb-1" for="newSim">
                      {{ sim_option_labels[1] }}
                    </label>
                  </div>
                }
                @if (simOptionAvailable('esim')) {
                  <div class="form-check ps-0">
                    <input
                      id="eSim"
                      class="d-inline-block me-1"
                      type="radio"
                      formControlName="sim_options"
                      value="esim"
                      (change)="selectSimOption($event)"
                    />
                    <label class="d-inline-block mb-1" for="eSim">
                      {{ sim_option_labels[2] }}
                    </label>
                  </div>
                }
              </div>
            </div>
            <div>
              @switch (sim_form.controls['sim_options'].value) {
                @case ('own') {
                  <label class="d-block my-1 required" for="simNumber">
                    {{ 'sim_number' | translate }}
                  </label>
                  <input
                    id="simNumber"
                    class="form-control has-validation"
                    formControlName="sim_input"
                    aria-errormessage="validationSIM"
                    [ngClass]="[
                      simInputValidationClasses('sim'),
                      sim_form.controls['sim_input'].errors?.['invalid'] ? 'is-invalid' : ''
                    ]"
                    (change)="simNumberInput($event)"
                  />
                  <div id="validationSIM" class="invalid-feedback">
                    {{
                      sim_form.controls['sim_input'].errors?.['invalid'] ??
                        ('enter_valid_sim' | translate)
                    }}
                  </div>
                }
                @case ('esim') {
                  <label class="d-block my-1 required" for="eid">
                    {{ 'eid' | translate }}
                  </label>
                  <input
                    id="eid"
                    class="form-control has-validation"
                    formControlName="sim_input"
                    aria-errormessage="validationEID"
                    [ngClass]="[
                      simInputValidationClasses('esim'),
                      sim_form.controls['sim_input'].errors?.['invalid'] ? 'is-invalid' : ''
                    ]"
                    (change)="simNumberInput($event)"
                  />
                  <div id="validationEID" class="invalid-feedback">
                    {{
                      sim_form.controls['sim_input'].errors?.['invalid'] ??
                        ('enter_valid_eid' | translate)
                    }}
                  </div>
                }
                @default {}
              }
            </div>
          </form>
        } @else {
          <span class="d-block mb-2 fw-normal">
            {{ 'how_to_activate_new_line' | translate }}
          </span>
          @if (sim_summary_details && sim_summary_details.new_sim) {
            <span>
              <span>{{ sim_option_labels[0] }}</span>
              <span class="d-block mt-2">
                <span class="fw-normal">{{ 'sim_number' | translate }}: </span>
                {{ sim_summary_details.new_sim }}
              </span>
            </span>
          }
          @if (sim_summary_details && sim_summary_details.order_sim) {
            <span>
              <span>{{ sim_option_labels[1] }}</span>
            </span>
          }
          @if (sim_summary_details && sim_summary_details.esim_activation) {
            <span>
              <span>{{ sim_option_labels[2] }}</span>
              <span class="d-block mt-2">
                <span class="fw-normal"> {{ 'eid' | translate }}: </span>
                {{ sim_summary_details.new_eid }}
              </span>
            </span>
          }
        }
      }
      @case ('loading') {
        <tds-loading-spinner />
      }
    }
  </div>
</div>
